import fetch from 'isomorphic-fetch';

import ApplicationVersion from './ApplicationVersion';

export default function loadApplicationVersion(): Promise<ApplicationVersion> {
	return fetch('/version.json', { cache: 'no-store' })
		.then((response) => response.json())
		.then((response) => new ApplicationVersion(response.build));
}
